(() => {
  const init = () => document.querySelectorAll('header.ww-unified-header').forEach(header => {
    if (header.dataset.stickyReady) return;
    header.dataset.stickyReady = 'true';
    const spacer = document.createElement('div');
    spacer.setAttribute('aria-hidden', 'true');
    header.before(spacer);
    const measure = () => {
      header.classList.remove('ww-nav-fixed', 'ww-nav-hidden');
      const overlay = getComputedStyle(header).position === 'absolute';
      const height = header.getBoundingClientRect().height;
      spacer.style.height = overlay ? '0px' : `${height}px`;
      document.documentElement.style.setProperty('--ww-nav-height', `${height}px`);
      header.classList.add('ww-nav-fixed');
    };
    measure();
    const show = () => header.classList.remove('ww-nav-hidden');
    addEventListener('resize', measure, {passive:true});
    header.addEventListener('focusin', show);
    header.addEventListener('toggle', show, true);
    header.addEventListener('keydown', event => {
      if (event.key === 'Escape') {
        header.querySelectorAll('details[open]').forEach(menu => { menu.open = false; menu.querySelector('summary')?.focus(); });
      }
    });
  });
  init();
  document.addEventListener('shopify:section:load', init);
})();
